<template>
  <div id="team-stats-two">
    <div class="background-all">
      <div class="user-top">
        <div class="avatar-box">
          <img src="https://img.yzcdn.cn/vant/cat.jpeg">
          <div class="years-all"><div>成立3年</div></div>
        </div>
        <p class="team-title">普拉迪特 华东足球队</p>
        <div class="active-address-box">
          <div class="active-address"><div>上海活跃排名 12</div></div>
        </div>
      </div>
      <div class="scope-box">
        <div class="scope-item">
          <img src="@/assets/images/team_state_scope_1.png">
          <div class="position-box">
            <div class="title">活动</div>
            <div class="num">1023</div>
          </div>
        </div>
        <div class="scope-item">
          <img src="@/assets/images/team_state_scope_2.png">
          <div class="position-box">
            <div class="title">活动</div>
            <div class="num">1023</div>
          </div>
        </div>
        <div class="scope-item">
          <img src="@/assets/images/team_state_scope_3.png">
          <div class="position-box">
            <div class="title">活动</div>
            <div class="num">1023</div>
          </div>
        </div>
        <div class="scope-item">
          <img src="@/assets/images/team_state_scope_4.png">
          <div class="position-box">
            <div class="title">活动</div>
            <div class="num">1023</div>
          </div>
        </div>
      </div>
      <div class="select-box">
        <div class="select-left">
          <div class="dis-flex">
            <div class="fill">2020</div>年
            <div class="fill mar-left">8</div>月
          </div>
          <img src="@/assets/images/right_arrow_ico.png">
        </div>
        <div class="select-left">
          <div class="dis-flex">
            <div>活动形式</div>
          </div>
          <img src="@/assets/images/right_arrow_ico.png">
        </div>
      </div>
      <div class="active-box">
        <div class="item-active">
          <div class="item-active-title">总活动</div>
          <div class="item-active-num">243场</div>
          <div class="active-progress-box">
            <div class="item-active-progress">
              <div>
                <div class="public-progress red-progress" v-if="false"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
            </div>
            <div class="item-active-progress">
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
            </div>
            <div class="item-active-progress">
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
            </div>
          </div>
          <div class="item-active-font">处于平台前10%</div>
        </div>
        <div class="item-active">
          <div class="item-active-title">场均参与</div>
          <div class="item-active-num">11.5人</div>
          <div class="active-progress-box">
            <div class="item-active-progress">
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
            </div>
            <div class="item-active-progress">
              <div>
                <div class="public-progress yellow-progress" v-if="false"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
            </div>
            <div class="item-active-progress">
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
            </div>
          </div>
          <div class="item-active-font">处于平台前10%</div>
        </div>
        <div class="item-active">
          <div class="item-active-title">年度均参与</div>
          <div class="item-active-num">11.5次</div>
          <div class="active-progress-box">
            <div class="item-active-progress">
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress red-progress" v-if="true"></div>
                <div class="big-progress-public big-red-progress" v-else></div>
              </div>
            </div>
            <div class="item-active-progress">
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress yellow-progress" v-if="true"></div>
                <div class="big-progress-public big-yellow-progress" v-else></div>
              </div>
            </div>
            <div class="item-active-progress">
              <div>
                <div class="public-progress green-progress" v-if="false"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
              <div>
                <div class="public-progress green-progress" v-if="true"></div>
                <div class="big-progress-public big-green-progress" v-else></div>
              </div>
            </div>
          </div>
          <div class="item-active-font">处于平台前10%</div>
        </div>
      </div>
      <div class="data-box">
        <div class="data-box-item">
          <div class="data-item-title">出勤排行榜</div>
          <div class="data-item-content">
            <div class="item">
              <div class="left">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right">
                <span class="all-num">45</span>
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="look-all"><div>查看完整榜单</div></div>
          </div>
        </div>
        <div class="data-box-item">
          <div class="data-item-title">出勤排行榜</div>
          <div class="data-item-content">
            <div class="item">
              <div class="left">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right">
                <span class="all-num">45</span>
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="look-all"><div>查看完整榜单</div></div>
          </div>
        </div>
        <div class="data-box-item">
          <div class="data-item-title">出勤排行榜</div>
          <div class="data-item-content">
            <div class="item">
              <div class="left">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right">
                <span class="all-num">45</span>
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="look-all"><div>查看完整榜单</div></div>
          </div>
        </div>
      </div>
      <div class="echarts-box"></div>
      <div class="data-box margin-center">
        <div class="data-box-item no-padding radius-left">
          <div class="data-item-title">出勤排行榜</div>
          <div class="data-item-content width-item-content">
            <div class="item">
              <div class="left">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right">
                <span class="all-num">45</span>
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="look-all"><div>查看完整榜单</div></div>
          </div>
        </div>
        <div class="data-box-item no-padding radius-right">
          <div class="data-item-title">出勤排行榜</div>
          <div class="data-item-content width-item-content">
            <div class="item">
              <div class="left">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right">
                <span class="all-num">45</span>
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="item">
              <div class="left-two">
                <img src="https://img.yzcdn.cn/vant/cat.jpeg">
                <span>陈晓晓</span>
              </div>
              <div class="right-two">
                <span class="all-num">45</span>
              </div>
            </div>
            <div class="look-all"><div>查看完整榜单</div></div>
          </div>
        </div>
      </div>
      <div class="progress-box">
        <div class="top">
          <div class="left-title">
            <div class="num">5届</div>
            <div class="font">参加赛事</div>
          </div>
          <div class="right-img">
            <div class="one">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              <span>1</span>
            </div>
            <div class="one">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              <span>1</span>
            </div>
            <div class="one">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg">
              <span>1</span>
            </div>
          </div>
        </div>
        <div class="progress-center-box">
          <div class="one-pro"></div>
          <div class="two-pro"></div>
          <div class="three-pro"></div>
        </div>
        <div class="width-progress-box">
          <div class="progress-font width-one">
            胜234
          </div>
          <div class="progress-font width-two">
            平234
          </div>
          <div class="progress-font width-three">
            负234
          </div>
        </div>
      </div>
      <div class="record-box">
        <div class="recode-item">
          <div class="left">
            <div class="num">75场</div>
            <div class="">训练</div>
          </div>
          <div class="right">
            <p>“ 热爱训练，有好的 训练，才有好的成绩！超过同期平台 43% 的球队 ”</p>
            <div class="scope">
              <div class="scope-btn"><div>分组对抗</div></div>
              <div class="scope-btn"><div>普通训练</div></div>
            </div>
          </div>
        </div>
        <div class="recode-item">
          <div class="left">
            <div class="num">75场</div>
            <div class="">训练</div>
          </div>
          <div class="right">
            <p>“ 热爱训练，有好的 训练，才有好的成绩！超过同期平台 43% 的球队 ”</p>
            <div class="scope">
              <div class="scope-btn"><div>分组对抗</div></div>
              <div class="scope-btn"><div>普通训练</div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="width-btn">
        <div class="detail-btn">
          <div>详情</div>
        </div>
      </div>
      <div class="bottom-logo">
        <img src="@/assets/images/bmb-footer-logo.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveScore',
  data() {
    return {
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss">
  .background-all{
    width:100%;
    /*height:2191px;*/
    background:linear-gradient(128deg,rgba(39,15,151,1) 0%,rgba(83,100,203,1) 32%,rgba(1,7,74,1) 100%);
    position: relative;
    .user-top{
      height: 202px;
      padding-top: 16px;
      box-sizing: border-box;
      .avatar-box img{
        width: 75px;
        height: 75px;
        border-radius: 50%;
      }
      .avatar-box{
        width: 75px;
        height: 80px;
        text-align: center;
        margin: 0 auto;
        position: relative;
        .years-all{
          max-width: 70px;
          padding: 0 4px;
          height: 13px;
          line-height: 13px;
          text-align: center;
          border-radius: 6px;
          background: #5161F9;
          color: #FFFFFF;
          font-size: 8px;
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -24px;
        }
      }
    }
  }
  .user-top .team-title{
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    margin-top: 22px;
  }
  .user-top .active-address-box{
    width: 100%;
    position: relative;
  }
  .user-top .active-address{
    height: 25px;
    text-align: center;
    line-height: 25px;
    background:linear-gradient(90deg,rgba(81,97,249,1) 0%,rgba(104,43,196,1) 100%);
    border-radius: 13px;
    padding: 0 11px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    color: #FFFFFF;
    margin-top: 10px;
  }
  .scope-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .scope-item{
      position: relative;
      width: 61px;
      height: 62px;
      margin-right: 4px;
      img{
        width: 61px;
        height: 62px;
        position: relative;
        top: 0;
        left: 0;
      }
      .title{
        color: #FFFFFF;
        font-size: 10px;
        position: absolute;
        top: 7px;
        left: 19px;
      }
      .num{
        color: #FFFFFF;
        font-size: 18px;
        position: absolute;
        top: 24px;
        left: 8px;
      }
    }
  }
  #team-stats-two .select-box{
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: center;
    margin-top: 36px;
    .select-left{
      width: 166px;
      height: 30px;
      background:rgba(240,240,240,0.25);
      border-radius:4px;
      font-size: 10px;
      color: #FFFFFF;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 6px;
      padding-right: 15px;
      box-sizing: border-box;
      .dis-flex{
        display: flex;
        padding-right: 15px;
        box-sizing: border-box;
      }
    }
  }
  #team-stats-two .select-box .select-left img{
    width: 12px;
    height: 12px;
  }
  #team-stats-two .select-box .select-left .fill{
    padding-right: 12px;
    box-sizing: border-box;

  }
  #team-stats-two .select-box .select-left .mar-left{
    margin-left: 10px;
  }
  .active-box{
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    padding: 0 16px;
    box-sizing: border-box;
    .item-active{
      width: 110px;
      height: 103px;
      background-color: #FFFFFF;
      border-radius: 4px;
      opacity: 0.99;
      margin-right: 7px;
      margin-top: 9px;
      .item-active-title{
        font-size: 10px;
        font-weight: 500;
        color: #000000;
        padding-top: 10px;
        box-sizing: border-box;
      }
      .item-active-num{
        font-size: 18px;
        color: #000000;
        padding-top: 8px;
        box-sizing: border-box;
      }
      .item-active-font{
        font-size: 10px;
        color: #999999;
      }
      .active-progress-box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 8px 0;
        .item-active-progress{
          display: flex;
          align-items: center;
          .public-progress{
            width: 8px;
            height: 2px;
            border-radius: 4px;
            margin-right: 1px;
          }
          .red-progress{
            background:rgba(204,51,50,0.2);
          }
          .green-progress{
            background:rgba(44,199,164,0.2);
          }
          .yellow-progress{
            background:rgba(223,164,2,0.2);
          }
          .big-progress-public{
            width: 8px;
            height: 5px;
            border-radius: 4px;
          }
          .big-red-progress{
            background:rgba(204,51,50,1);
          }
          .big-green-progress{
            background:rgba(44,199,164,1);
          }
          .big-yellow-progress{
            background:rgba(223,164,2,1);
          }
        }
      }
    }
  }
  #team-stats-two .data-box{
    width: 100%;
    max-width: 343px;
    margin: 0 auto;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    &::-webkit-scrollbar{
      display: none;
    }
    .data-box-item{
      width: 180px;
      height: 218px;
      background-color: #FFFFFF;
      border-radius: 4px;
      box-shadow:-5px 5px 10px 0px rgba(68,215,182,0);
      margin-top: 31px;
      margin-right: 13px;
    }
    .data-item-title{
      height: 30px;
      line-height: 30px;
      background-color: #F2F2F2;
      font-size: 14px;
      color: #5161F9;
      font-weight: 500;
      text-align: center;
    }
  }
  .data-item-content{
    padding: 23px 11px 0;
    box-sizing: border-box;
    position: relative;
    width: 180px;
    height: 188px;
    .item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      .left{
        display: flex;
        align-items: center;
        img{
          width: 20px;
          height: 20px;
          display: block;
          font-size: 14px;
          color: #5161F9;
          margin-right: 10px;
        }
      }
      .left-two{
        display: flex;
        align-items: center;
        img{
          width: 16px;
          height: 16px;
          display: block;
          font-size: 14px;
          color: #5161F9;
          margin-right: 10px;
        }
      }
      .right{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        img{
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: block;
          margin-left: 7px;
        }
        span{
          color: #5161F9;
          font-size: 12px;
        }
      }
      .right-two{
        display: flex;
        align-items: center;
        padding-right: 9px;
        box-sizing: border-box;
        img{
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: block;
          margin-left: 7px;
        }
        span{
          color: #5161F9;
          font-size: 12px;
        }
      }
    }
    .look-all{
      width: 79px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 9px;
      border: 1px solid #5161F9;
      color: #5161F9;
      font-size: 11px;
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .echarts-box{
    width: 343px;
    height: 222px;
    background: #FFFFFF;
    margin: 10px auto;
  }
  .margin-center{
    justify-content: center;
    width: 343px !important;
    margin: 0 auto;
    overflow: visible !important;
    padding-left: 0 !important;
  }
  .no-padding{
    margin-right: 0 !important;
    width: 171px !important;
  }
  .width-item-content{
    width: 171px !important;
  }
  .radius-left{
    border-bottom-right-radius: 0 !important;
  }
  .radius-right{
    border-bottom-left-radius: 0 !important;
  }
  .progress-box{
    width: 343px;
    height: 182px;
    background: #FFFFFF;
    border-radius: 4px;
    margin: 32px auto 0;
    padding: 28px 21px;
    box-sizing: border-box;
    .top{
      display: flex;
      justify-content: space-between;
      align-items: last;
      .left-title{
        padding-right: 20px;
        box-sizing: border-box;
        text-align: center;
        .num{
          color: #000000;
          font-size: 30px;
        }
        .font{
          color: #000000;
          font-size: 14px;
        }
      }
      .right-img{
        display: flex;
        align-items: center;
        .one{
          display: flex;
          align-items: center;
          color: #000000;
          font-size: 24px;
          margin-right: 31px;
          img{
            width: 20px;
            height: 20px;
            display: block;
            margin-right: 13px;
          }
        }
      }
    }
  }
  .progress-center-box{
    margin-top: 28px;
    display: flex;
    width: 342rpx;
    position: relative;
    .one-pro{
      width: 20%;
      height: 19px;
      background: #44D7B6;
      border-bottom-left-radius: 9px;
      border-top-left-radius: 9px;
    }
    .two-pro{
      width: 60%;
      height: 19px;
      background: #32C5FF;
      border-bottom-left-radius: 9px;
      border-top-left-radius: 9px;
      margin-left: -7px;
    }
    .three-pro{
      width: 20%;
      height: 19px;
      background: #F77300;
      border-radius: 9px;
      margin-left: -7px;
    }
  }
  .width-progress-box{
    display: flex;
    width: 342rpx;
    .progress-font{
      text-align: center;
      margin-top: 9px;
    }
    .width-one{
      width: 20%;
    }
    .width-two{
      width: 60%;
    }
    .width-three{
      width: 20%;
    }
  }
  .record-box{
    padding: 37px 26px 0;
    box-sizing: border-box;
    .recode-item{
      display: flex;
      margin-bottom: 50px;
      position: relative;
      .left{
        width: 81px;
        height: 81px;
        line-height: 25px;
        border: 1px solid #FCDB00;
        box-shadow:0px 2px 4px 0px rgba(247,181,0,0.2);
        border-radius: 50%;
        text-align: center;
        padding-top: 14px;
        box-sizing: border-box;
        color: #FFFFFF;
      }
      .right{
        width: 212px;
        margin-left: 25px;
        position: relative;
        p{
          font-size: 14px;
          color: #F2F2F2;
          position: absolute;
          top: -16px;
        }
        .scope{
          display: flex;
          justify-content: center;
          position: absolute;
          bottom: 0;
          .scope-btn{
            height: 19px;
            line-height: 19px;
            text-align: center;
            border-radius: 10px;
            background:rgba(255,255,255,0.3);
            padding: 0 10px;
            margin-right: 10px;
            color: #FFFFFF;
            font-size: 10px;
          }
        }
      }
    }
  }
  .width-btn{
    margin-top: 44px;
    padding-bottom: 140px;
    .detail-btn{
      width: 92px;
      height: 23px;
      line-height: 23px;
      text-align: center;
      border: 1px solid #FFFFFF;
      border-radius: 16px;
      color: #FFFFFF;
      font-size: 12px;
      margin: 0 auto;
      opacity:0.99;
    }
  }
  .bottom-logo{
    position: absolute;
    bottom: 33px;
    left: 50%;
    transform: translateX(-50%);
    background: #FFFFFF;
    img{
      width: 54px;
      height: 23px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/team-stats/index.vue